import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthLayoutComponent } from "./shared/components/layouts/auth-layout/auth-layout.component";
import { AuthGaurd } from "./shared/services/auth.gaurd";
import { BlankLayoutComponent } from "./shared/components/layouts/blank-layout/blank-layout.component";
import { AdminLayoutSidebarLargeComponent } from "./shared/components/layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component";
import { SiteNoteAvailableComponent } from "./SiteNoteAvailable/SiteNoteAvailable.component";
import { DashboardComponent } from "./modules/dashboard/dashboard.component";

const adminRoutes: Routes = [
  {
    path: "dashboard",
    canActivate: [AuthGaurd],
    // component: DashboardComponent,
    loadChildren: () =>
      import("./modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "admin",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/admin/admin.module").then((m) => m.AdminModule),
  },
 
 

  {
    path: "team",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/Settings/team-management/team-management.module").then(
        (m) => m.TeamManagement
      ),
  },
  
  {
    path: "setting",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/Settings/settings.module").then(
        (m) => m.SettingsModule
      ),
  },
  {
    path: "subscriptions",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/subscriptions/subscriptions.module").then(
        (m) => m.SubscriptionsModule
      ),
  },
  
  {
    path: "Import-Export",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/import-export/import-export.module").then(
        (m) => m.ImportExportModule
      ),
  },
  {
    path: "propsects",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/propsects/propsects.module").then(
        (m) => m.PropsectsModule
      ),
  },
  {
    path: "tenant",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/tenant/tenant.module").then(
        (m) => m.AccountModule
      ),
  },
  {
    path: "environment-config",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./modules/environment-config/environment-config.module").then(
        (m) => m.EnvironmentConfigModule
      ),
  },
];

const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "sessions",
        loadChildren: () =>
          import("./modules/sessions/sessions.module").then(
            (m) => m.SessionsModule
          ),
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutSidebarLargeComponent,
    canActivate: [AuthGaurd],
    children: adminRoutes,
  },
  {
    path: "**",
    redirectTo: "others/404",
  },
  {
    path: "site-not-available",
    component: SiteNoteAvailableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
